import { CalendarTask } from '../pages/plan/calendar/types.ts';
import WedifyApiRequest from './wedify_api_request.js';


export const saveCalenderEvent = async (body: CalendarTask) => {
  try {
    const wedifyApiRequest = new WedifyApiRequest();
    console.log(body)
    const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/calendar/events`, 'POST', JSON.stringify(body) as any)
    if (response && response.ok) {
      return await response.json()
    } else {
      console.log("Saving calender event failed");
    }
  } catch (error) {
    console.error('Error sending message to Discord:', error);
    throw error;
  }
};

export const getCalenderEvents = async () => {
  try {
    const wedifyApiRequest = new WedifyApiRequest();
    const response = await wedifyApiRequest.makeRequest(`${process.env.REACT_APP_API_BASE_URL}/api/calendar/events`, "GET")
    if (response && response.ok) {
      return await response.json()
    } else {
      console.log("Fetching calender events failed");
    }
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};